import React from 'react';
import { FiFacebook, FiInstagram } from "react-icons/fi";

const CopyrightTwo = () => {
    return (
        <div className="copyright-area copyright-style-one variation-two">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-7 col-sm-12 col-12">
                        <div className="copyright-left">
                            <ul className="ft-menu link-hover">
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 mt_sm--20">
                        <div className="copyright-center text-center">
                            <ul className="social-icon social-default color-lessdark justify-content-center">
                            <li><a target="_blank" rel="noopener noreferrer" aria-label="BlackWave na Facebooku" href="https://www.facebook.com/profile.php?id=61561259094203"><FiFacebook /></a></li>
                                        <li><a target="_blank" rel="noopener noreferrer" aria-label="BlackWave na Instagramie" href="https://www.instagram.com/blackwave_augustow?igsh=bjFjcXV4aHJnYXh3"><FiInstagram /></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12 mt_md--20 mt_sm--20">
                        <div className="copyright-right text-center text-lg-right">
                            <p className="copyright-text">Copyright All rights reserved © {new Date().getFullYear()} <a href="https://softech.app" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px', textDecoration: 'underline' }}>BlackWave.</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CopyrightTwo;